import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {  InfoBo, InfoBoLink, QResult, Select } from "../../../../models";
import { CoreService, HttpService } from "../../../../services";
import { StageService } from "../services/stage-modal.service";




@Injectable()
export class DocumentService implements OnDestroy {

  constructor(
    public service: StageService,
    protected http: HttpService,
    protected indParam: CoreService,
  ) { }


  public reportsList: Array<Select> = [
    { id: 'Pas de génération', value: '0' },
    { id: 'Rapport Digital learning', value: '1' },
    { id: 'Rapport connaissance avant aprés', value: 'Ques1PRO' },
    { id: 'Rapport pratique avant aprés', value: 'Ques2PRO' },
    { id: 'Rapport satisfaction stagiaire', value: 'Ques5PRO' },
    { id: 'Rapport satisfaction RH', value: 'Ques6PRO' },
    { id: 'Rapport satisfaction formateur', value: 'Ques7PRO' },
    { id: 'Rapport évaluation à froid', value: 'Ques8PRO' },
    { id: 'Rapport certification', value: 'Ques9PRO' },
  ];


  public tabs: Array<{ Type: DocumentOnglet, Font: string, Name: string, Active: boolean, Visible: boolean, Locked: boolean }> = [
    { Active: true, Visible: true, Locked: false, Name: 'Liste des documents', Type: DocumentOnglet.ListDocuments, Font: 'fas fa-book mr-2', },
    { Active: false, Visible: true, Locked: false, Name: 'Génération docs', Type: DocumentOnglet.GenerationDocuments, Font: 'fas fa-print mr-2', },
    { Active: false, Visible: true, Locked: false, Name: 'Génération Contrat formateur', Type: DocumentOnglet.GenerationContratFormateur, Font: 'fas fa-file-contract mr-2', }
  ];

  public nivseDOCOptions: Array<Select>;

  public GetNiveauDocExtranet(): Observable<QResult<Array<Select>>> {
    return this.http.getHttp<QResult<Array<Select>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/INIT_DOCUMENT/${this.service.Stage.Ident}`)
      .pipe(
        map((result: QResult<Array<Select>>) => {

          if (!result.HasError) {
            this.nivseDOCOptions = result.Value;
          }
          return result;
        })
      );
  }

  public GetEffectifDocumentLink(effectifsSelectionnes: InfoBo): Observable<Array<string>> {
    return this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/bobject/GET_LINKS`, effectifsSelectionnes).pipe(
      map((listIdent: QResult<Array<string>>) => {        
        return listIdent.Value;
    }));

  }     

  public PostSaveEffectifLink(effectifsSelectionnesAdd: Array<InfoBo>) {
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/bobject/ADD_LINKS`, effectifsSelectionnesAdd).subscribe((data: any) => {      
    });
  }

  
  public UpdateMontantContrat(idContrat: string): Observable<boolean>{
    return this.http.getHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Document/UPDATE_CONTRAT_MONTANT/${idContrat}`).pipe(
      map((data: any) => {      
      return true;
    }));
  }


  public PostUpdateEffectifLink(effectifsSelectionnesUpdate: Array<InfoBoLink>): Observable<boolean> {
    return this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/bobject/UPDATE_LINKS`, effectifsSelectionnesUpdate).pipe(
      map((data: any) => {      
      return true;
    }));
  }

  ngOnDestroy(): void { }
}
export enum DocumentOnglet {
  ListDocuments,
  GenerationDocuments,
  GenerationContratFormateur,
}
